import React from 'react';

const HorLoader = () => {
	return (
		<div>
			<div className='horizontal-bar-wrap' style={{}}>
				<div className='bar1 bar'></div>
			</div>
		</div>
	);
};

export default HorLoader;
